var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    stroke: "#8A8A8A",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 15.6667C11.8423 15.6667 13.3346 14.1743 13.3346 12.3333C13.3346 10.4924 11.8423 9 10.0013 9C8.16035 9 6.66797 10.4924 6.66797 12.3333C6.66797 14.1743 8.16035 15.6667 10.0013 15.6667Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69922 12.4163L9.24089 12.9579C9.39922 13.1163 9.65755 13.1163 9.81589 12.9663L11.2992 11.5996",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66734 18.8333H13.334C16.684 18.8333 17.284 17.4917 17.459 15.8583L18.084 9.19167C18.309 7.15833 17.7257 5.5 14.1673 5.5H5.834C2.27567 5.5 1.69234 7.15833 1.91734 9.19167L2.54234 15.8583C2.71734 17.4917 3.31734 18.8333 6.66734 18.8333Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 5.5013V4.83464C6.66797 3.35964 6.66797 2.16797 9.33464 2.16797H10.668C13.3346 2.16797 13.3346 3.35964 13.3346 4.83464V5.5013",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0418 9.66797C16.6001 10.718 15.0001 11.4513 13.3418 11.868",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18359 9.89062C3.57526 10.8406 5.09193 11.5156 6.66693 11.899",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.5e1ac23217c95e5c90ef7f4123611bda.svg";
export { ForwardRef as ReactComponent };